import { getCookieUserInfo } from '@csair/emp-helpers';
import {
  CHANGE_NAVBAR_STATE,
  SAVE_OLD_LOCATION,
  GET_SYS_CONFIG,
  GET_APP_CONFIG,
  GET_USER_INFO,
  GET_PASSAGEMEMBER_LEVEL,
  GET_LANGUAGE,
  GET_MILEAGE_SWITCH,
} from './actions';
import Cookies from 'js-cookie';
import sha256 from 'js-sha256';
/**
 * userInfo
 *  createTime: 1505145600000 创建日期
 *  easyLoginRequest: false
 *  identifyStatus: null 认证 Y是 N否
 *  loginType 登录类型 6：会员登录；7：非会员登录； 8：直接接入；15：简易登录（20180428新增）；17：扫登机牌登录 99 员工登录（特定）
 *  memberNo 会员号
 *  memberType 会员类型：EM(E行会员）/ FFPM（明珠会员）
 *  mobile
 *  name
 *  upgrading
 */

let initialState = {
  navBar: {
    display: true,
  },
  lang: {},
  oldLocation: {},
  sysConfig: {
    is_Easy_Login_Turn_On: false,
    is_authenticate_turn_on: false,
    is_recommend_turn_on: false,
    has_luck_draw_movable_switch_bool: false,
    the_flag_fastchange: false,
  },
  appConfig: {
    moreQuery: process.env.REACT_APP_MOREQUERY === 'true',
  },
  userInfo: {},
  memberList: {},
  switchMieage: {},
};

export default function TicketChangesReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_NAVBAR_STATE:
      return Object.assign({}, state, { navBar: { display: action.state } });
    case SAVE_OLD_LOCATION:
      return Object.assign({}, state, { oldLocation: action.data });
    case `${GET_SYS_CONFIG}_SUCCESS`:
    case `${GET_APP_CONFIG}_SUCCESS`:
      return action.payload.data
        ? Object.assign({}, state, {
          sysConfig: Object.assign(
            {},
            state.sysConfig,
            action.payload.data.map || action.payload.data
          ),
        })
        : state;
    case `${GET_USER_INFO}_SUCCESS`:
      if (action.payload.data) {
        const cookieLoginType = getCookieUserInfo();
        if (cookieLoginType === 'OA') {
          action.payload.data.data.info.loginType = '99';
        }
        // let vconsole = document.getElementById('__vconsole');
        // vconsole ? vconsole.style.display = 'none' : '';
        // if (
        //   [
        //     '118218337593','149459309923'
        //   ].includes(action.payload.data.data.memberNo)
        // ) {
        //   vconsole ? vconsole.style.display = 'block' : '';
        // }
        const userID = sha256(action.payload.data.data.memberNo)
        Cookies.set('userId', userID);
        window.bonreeJsBridge && window.bonreeJsBridge.setUserID(userID);
        return Object.assign({}, state, {
          userInfo: action.payload.data.data,
        });
      }
      return state;
    // case `${GET_PASSAGEMEMBER_LEVEL}_SUCCESS`:
    //   if (action.payload.data) {
    //     return Object.assign({}, state, {
    //       memberList: { memberList: action.payload.data.data },
    //     });
    //   }
    // return state;
    case `${GET_MILEAGE_SWITCH}_SUCCESS`:
      if (action.payload.data) {
        return Object.assign({}, state, {
          switchMieage: action.payload.data,
        });
      }
      return state;
    case GET_LANGUAGE:
      if (action.lang) {
        return Object.assign({}, state, {
          lang: action.lang,
        });
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/modules/app.js